module.exports = __webpack_public_path__ + "static/img/zhzx_hover.fc1ffc96.gif";